<template>
  <div>
    <BannerText
      :textFlag="false"
      :imgUrl="
        $baseImgUrl + 'api/sys/common/static/homeBarrageImg/teacherBanner.png'
      "
    />
    <section id="bigBox">
      <div class="course_detail_box module_box">
        <h1 class="main_title">课程详情</h1>
        <div class="detail_img_box sub_module_box">
          <el-carousel :interval="15000" arrow="always" height="494px">
            <el-carousel-item>
              <img src="../assets/img/businessImg1.png" alt="" />
            </el-carousel-item>
            <el-carousel-item>
              <img src="../assets/img/img2.png" alt="" />
            </el-carousel-item>
            <el-carousel-item>
              <img src="../assets/img/bgImg.png" alt="" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <div class="detail_content_box sub_module_box">
        <h1 class="main_title">企业数智化经营入门</h1>
        <div class="sub_title">
          <p>战略不是在忙碌中盲目生长</p>
          <p>2026年4月11日</p>
        </div>
        <p>
          战略不是在忙碌中盲目生长战略不是在忙碌战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长战略不是在忙碌中盲目生长
        </p>
        <div @click="$utils.goPage('/ApplyCourse')">申请课程</div>
      </div>
    </section>
  </div>
</template>

<script>
import BannerText from "@/components/BannerText.vue";
export default {
  name: "CourseDetail",
  components: {
    BannerText,
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="less">
.course_detail_box,
.detail_content_box {
  width: 100%;
  padding: 0 8%;
  box-sizing: border-box;
}
.detail_img_box {
  width: 100%;
  height: 494px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 20px rgba(0, 0, 0, 0.25);
  .el-carousel__item > img {
    width: 100%;
    height: 100%;
  }
  // 穿透修改分页器样式
  ::v-deep .el-carousel__indicator {
    // 未激活状态
    .el-carousel__button {
      background: rgba(184, 200, 255, 1);
      border: none; // 去除默认边框（可选）
      opacity: 1; // 确保颜色完全显示
    }
    // 激活状态
    &.is-active {
      .el-carousel__button {
        background: rgba(69, 111, 255, 1);
        border: none; // 去除默认边框（可选）
        opacity: 1; // 确保颜色完全显示
      }
    }
  }
}
.detail_content_box {
  width: 100%;
  text-align: center;
  > h1 {
    font-size: 1.875rem;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
  }
  .sub_title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 40px 0;
    > p {
      font-size: 1rem;
      font-weight: 400;
    }
    > p:last-of-type {
      color: rgba(117, 117, 117, 1);
      margin-left: 20px;
    }
  }
  > p {
    max-width: 884px;
    margin: 0 auto;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 30px;
    color: rgba(0, 0, 0, 1);
    text-indent: 2em;
    text-align: left;
    letter-spacing: 1px;
  }
  > div:last-of-type {
    width: 170px;
    height: 50px;
    opacity: 1;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.25rem;
    font-weight: 400;
    margin: 50px auto;
    color: rgba(255, 255, 255, 1);
    background: linear-gradient(
      90deg,
      rgba(156, 179, 255, 1) 0%,
      rgba(2, 181, 232, 1) 100%
    );
  }
}
</style>
